/**
 * ScenarioSwitcher — segmented control à 3 segments pour choisir le scénario
 * de projection cash-flow : Pessimiste / Médian / Optimiste.
 *
 * Props :
 *   value    : 'pessimiste' | 'median' | 'optimiste'
 *   onChange : (scenario: string) => void
 */
const SCENARIOS = [
  {
    value: 'pessimiste',
    label: 'Pessimiste',
    activeClass: 'bg-red-100 text-red-700',
    inactiveClass: 'text-slate-500 hover:text-slate-700 hover:bg-slate-50',
  },
  {
    value: 'median',
    label: 'Médian',
    activeClass: 'bg-slate-800 text-white',
    inactiveClass: 'text-slate-500 hover:text-slate-700 hover:bg-slate-50',
  },
  {
    value: 'optimiste',
    label: 'Optimiste',
    activeClass: 'bg-emerald-100 text-emerald-700',
    inactiveClass: 'text-slate-500 hover:text-slate-700 hover:bg-slate-50',
  },
];

export default function ScenarioSwitcher({ value, onChange }) {
  return (
    <div
      className="inline-flex rounded-lg border border-slate-200 overflow-hidden text-xs"
      role="group"
      aria-label="Scénario de projection"
    >
      {SCENARIOS.map((s) => {
        const isActive = value === s.value;
        return (
          <button
            key={s.value}
            type="button"
            onClick={() => onChange(s.value)}
            aria-pressed={isActive}
            className={`
              px-3 py-1.5 font-medium transition-colors whitespace-nowrap
              ${isActive ? s.activeClass : s.inactiveClass}
            `}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
